import React, { useState, useEffect } from "react";
import "./Withdraw.css";
// import "../../../src/App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaFileUpload } from "react-icons/fa";
import Header from "../header/Header";
import ExposureHeader from '../ExposureHeader/ExposureHeader';
import Appconfig from '../../config/config'
import Helper from "../../helper";
import axios from 'axios';
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Modal, Input, Table, Image, Button, Switch } from 'antd';
import { getPaymentMethods } from '../../redux/slice/paymentMethod/paymentMethodSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";



const Withdraw = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userInfo = Helper();
  const userInfos = useSelector((state) => state.paymentMethods); // Use selector to access state
  const paymentMethod = userInfos?.paymentMethods || [];
  console.log('paymentMethod', paymentMethod)

  const [balance, setBalance] = useState(0)
  const [exposure, setExposure] = useState(0)
  let balanceWithExp = balance - Math.abs(exposure);


  const [inputValue, setInputValue] = useState("");
  const [selectedOption, setSelectedOption] = useState("new-account"); // Set default to 'new-account'
  const [isSubmitted, setIsSubmitted] = useState(false); // State for form submission
  const [buttonText, setButtonText] = useState("Submit"); // State for button text
  const [showPaymentMethods, setShowPaymentMethods] = useState(false);
  const [showAddAccountForm, setAddAccountForm] = useState(false);
  const [showBankForm, setShowBankForm] = useState('');
  const [showUpiForm, setShowUpiForm] = useState('');
  const [showEditPopup, setShowEditPopup] = useState(false); // State to handle Edit form popup visibility
  const [editingSection, setEditingSection] = useState(null); // Track which section is being edited
  const [showPreviousAccount, setShowPreviousAccount] = useState(false);
  const [selectedPaymentDetail, setSelectedPaymentDetail] = useState(null); // Track selected payment method detail
  const [amountValue, setAmountValue] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountHolder, setAccountHolder] = useState("");
  const [bankName, setBankName] = useState("");
  const [showWithdrawHistory, setShowWithdrawHistory] = useState(false);



  const [upiId, setUpiId] = useState("");
  const [upiHolder, setUpiHolder] = useState("");
  const [button, setButton] = useState(false)



  const [AcNumValidationError, setAcNumValidationError] = useState("Please enter account number");
  const [AcHolderValidationError, setAcHolderValidationError] = useState("Please enter account holder name");
  const [IfscValidationError, setIfscValidationError] = useState("Please enter ifsc code");
  const [BankValidationError, setBankValidationError] = useState("Please enter bank name");
  const [UPIValidationError, setUPIValidationError] = useState("Please enter id");
  const [HolderValidationError, setHolderValidationError] = useState("Please enter holder name");

  const [withdrawHistory, setWithdrawHistory] = useState([]);
  const location = useLocation();



  const [bankDetails, setBankDetails] = useState({
    name: "Example",
    accountNumber: "12345678xxxx",
    ifscCode: "SBIN000002",
    bankName: "State Bank of India",
  });

  const [UPIDetails, setUPIDetails] = useState({
    upi_id: "1234fgd",
    phoneNumber: "12345678xxxx",
  });

  // Handle changes in the Bank input fields during editing
  const handleBankInputChange = (e) => {
    const { name, value } = e.target;
    setBankDetails({
      ...bankDetails,
      [name]: value,
    });
  };


  useEffect(() => {
    getUserPaymentMethods();
  }, [location]); // refetch when route changes (including after adding a method)

  const getUserPaymentMethods = () => {
    dispatch(getPaymentMethods({
      site_code: Appconfig.sitecodes,
      user_id: userInfo?._id
    }));
  }




  useEffect(() => {
    if (userInfo) {
      getBalance();
    }
  }, [userInfo])

  function getBalance() {
    var data = JSON.stringify({
      user_id: userInfo?._id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}ledger/getUserBalance`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result == 0) {
        } else {
          setBalance(response.data.resultData?.balance)
          setExposure(response.data.resultData?.exposure)
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }


  // Handle changes in the UPI input fields during editing
  const handleUPIInputChange = (e) => {
    const { name, value } = e.target;
    setUPIDetails({
      ...UPIDetails,
      [name]: value,
    });
  };

  const toggleEditPopup = (section) => {
    setEditingSection(section); // Set the section (either "bank" or "upi")
    setShowEditPopup(!showEditPopup); // Toggle the popup
  };

  function deletePaymentDetails(id) {
    var data = JSON.stringify({
      id: id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}paymentMethod/deleteType`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          toast.success(response.data.resultMessage, { autoClose: 2000 });
          getUserPaymentMethods();
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const handlePreviousAccount = () => {
    setShowPreviousAccount(!showPreviousAccount);
    setShowPaymentMethods(false)
  }

  // Function to handle button click
  const handleButtonClick = (value) => {
    setInputValue(value);
  };

  // Function to handle payment option click
  const handleClick = (option) => {
    setSelectedOption(selectedOption === option ? null : option); // Toggle between opening/closing
  };

  const handlePaymentMethod = () => {
    setShowPaymentMethods(!showPaymentMethods);
    setShowPreviousAccount(false);

    // Hide all forms using an array of form setters
    [
      setShowUpiForm,
    ].forEach((setter) => setter(false));
  };

  const handleFormToggle = (form) => {
    setUpiId("");
    setUpiHolder("");
    setShowUpiForm(form);
  };

  // Button values
  const buttonValues = [500, 1000, 1500, 2000, 2500, 3000];

  const tickMark = (
    <svg
      width="58"
      height="45"
      viewBox="0 0 58 45"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#fff"
        fillRule="nonzero"
        d="M19.11 44.64L.27 25.81l5.66-5.66 13.18 13.18L52.07.38l5.65 5.65"
      />
    </svg>
  );

  function checkValidation() {

    if (showUpiForm == "Bank") {
      console.log('accountNumber', accountNumber);
      if (!accountNumber) {
        setAcNumValidationError('Please enter account number')
        document.querySelector('.acnum').classList.remove('hidden');
      }
      if (!accountHolder) {
        setAcHolderValidationError('Please enter holder name')
        document.querySelector('.acholder').classList.remove('hidden');
      }
      if (!ifscCode) {
        setIfscValidationError('Please enter ifsc code')
        document.querySelector('.ifsccode').classList.remove('hidden');
      }

      if (!bankName) {
        setBankValidationError('Please enter bank name')
        document.querySelector('.bankname').classList.remove('hidden');
      }

      if (accountNumber && accountHolder && ifscCode && bankName) {
        return true
      }
      return false;
    } else {
      if (!upiId) {
        setUPIValidationError('Please enter upi id')
        document.querySelector('.upiid').classList.remove('hidden');
      }
      if (!upiHolder) {
        setHolderValidationError('Please enter holder name')
        document.querySelector('.holder').classList.remove('hidden');
      }
      if (upiId && upiHolder) {
        return true
      }
      return false;
    }
  }

  // Handle submit click and toggle button text & style
  const handleSubmitClick = async (e) => {
    e.preventDefault();

    if (userInfo && showUpiForm && amountValue) {

      if (checkValidation()) {

        const formData = new FormData();

        formData.append("master_id", userInfo?.master_id);
        formData.append("user_id", userInfo?._id);
        formData.append("site_code", userInfo?.site_code);
        formData.append("user_name", userInfo?.user_name);
        formData.append("type", showUpiForm);
        formData.append("bank_name", bankName);
        formData.append("account_no", accountNumber);
        formData.append("account_holder_name", accountHolder);
        formData.append("ifsc_code", ifscCode);
        formData.append("holder_name", upiHolder);
        formData.append("upi_id", upiId);
        formData.append("amount", amountValue);
        formData.append("admin_mobile_number", Appconfig.admin_mobile_number);

        var config = {
          method: 'post',
          url: `${Appconfig.apiUrl}withdraw/addWithdrawRequest`,
          headers: {
            'Content-Type': 'application/json'
          },
          data: formData
        };
        axios(config)
          .then(function (response) {
            if (response.data.result) {
              setButtonText("Thanks");
              setIsSubmitted(true);
              toast.success(response.data.resultMessage, { autoClose: 2000 });

              setTimeout(() => {
                navigate("/");
              }, 2000);

            } else {
              toast.error(response.data.resultMessage, { autoClose: 2000 });
            }

          })
          .catch(function (error) {
            console.log(error);
          });
      }
    } else {
      toast.error("Please select payment method or fill all the fields!", { autoClose: 2000 });
    }
  };

  function cancelWithdrawRequest(record, status) {
    setButton(true)
    var data = JSON.stringify({
      record: record,
      status: status,
      master_details: userInfo,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}withdraw/confirmWithdraw`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          toast.success(response.data.resultMessage, { autoClose: 2000 });
          getWithdrawHistory();
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
        setButton(false)
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // const historyColumns = [
  //   {
  //     title: 'User Name',
  //     sorter: true,
  //     render: (_, record) => (
  //       <span className=''>
  //         {record?.user_name}
  //       </span>
  //     ),
  //   },
  //   // {
  //   //   title: 'User Id',
  //   //   sorter: true,
  //   //   render: (_, record) => (
  //   //     <span className=''>
  //   //       {record?.user_id}
  //   //     </span>
  //   //   ),
  //   // },
  //   {
  //     title: 'Type',
  //     sorter: true,
  //     render: (_, record) => (
  //       <span className=''>
  //         {record?.type}
  //       </span>
  //     ),
  //   },
  //   ...(withdrawHistory.some((record) => record.bank_name) // Check if any record has a bank name
  //     ? [
  //       {
  //         title: 'Bank Name',
  //         sorter: true,
  //         render: (_, record) => (
  //           <span className=''>
  //             {record?.bank_name || 'N/A'}
  //           </span>
  //         ),
  //       },
  //     ]
  //     : []), // If no record has a bank name, exclude this column
  //   ...(withdrawHistory.some((record) => record.account_no) // Check if any record has a bank name
  //     ? [
  //       {
  //         title: 'Account Num',
  //         sorter: true,
  //         render: (_, record) => (
  //           <span className=''>
  //             {record?.account_no || 'N/A'}
  //           </span>
  //         ),
  //       },
  //     ]
  //     : []), // If no record has a bank name, exclude this column
  //   ...(withdrawHistory.some((record) => record.account_holder_name) // Check if any record has a bank name
  //     ? [
  //       {
  //         title: 'Account Holder Name',
  //         sorter: true,
  //         render: (_, record) => (
  //           <span className=''>
  //             {record?.account_holder_name || 'N/A'}
  //           </span>
  //         ),
  //       },
  //     ]
  //     : []), // If no record has a bank name, exclude this column
  //   ...(withdrawHistory.some((record) => record.ifsc_code) // Check if any record has a bank name
  //     ? [
  //       {
  //         title: 'IFSC Code',
  //         sorter: true,
  //         render: (_, record) => (
  //           <span className=''>
  //             {record?.ifsc_code || 'N/A'}
  //           </span>
  //         ),
  //       },
  //     ]
  //     : []), // If no record has a bank name, exclude this column
  //   ...(withdrawHistory.some((record) => record.upi_id) // Check if any record has a bank name
  //     ? [
  //       {
  //         title: 'UPI Id',
  //         sorter: true,
  //         render: (_, record) => (
  //           <span className=''>
  //             {record?.upi_id || 'N/A'}
  //           </span>
  //         ),
  //       },
  //     ]
  //     : []), // If no record has a bank name, exclude this column
  //   ...(withdrawHistory.some((record) => record.holder_name) // Check if any record has a bank name
  //     ? [
  //       {
  //         title: 'Holder Name',
  //         sorter: true,
  //         render: (_, record) => (
  //           <span className=''>
  //             {record?.holder_name || 'N/A'}
  //           </span>
  //         ),
  //       },
  //     ]
  //     : []), // If no record has a bank name, exclude this column
  //   {
  //     title: 'Remarks',
  //     sorter: true,
  //     render: (_, record) => (
  //       <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
  //         {record?.remark}
  //       </span>
  //     ),
  //   },
  //   {
  //     title: 'Amount',
  //     sorter: true,
  //     render: (_, record) => (
  //       <span className=''>
  //         {record?.amount}
  //       </span>
  //     ),
  //   },
  //   {
  //     title: 'Request Date',
  //     sorter: true,
  //     render: (_, record) => (
  //       <span className=''>
  //         {(new Date(record?.createdAt)).toLocaleString()}
  //       </span>
  //     ),
  //   },
  //   {
  //     title: 'Status',
  //     sorter: true,
  //     render: (_, record) => (
  //       <div className='' >
  //         {
  //           record?.status == 'Request' ?
  //             <button disabled={button} onClick={() => cancelWithdrawRequest(record, 'Cancel')} className='custom-button'>
  //               <span>Cancel</span>
  //             </button> : record?.status
  //         }
  //       </div>
  //     ),
  //   },
  // ];

  const historyColumns = [
    {
      title: "User Name",
      sorter: true,
      render: (_, record) => (
        <span className="font-semibold text-gray-800 text-sm">
          {record?.user_name}
        </span>
      ),
    },
    {
      title: "Type",
      sorter: true,
      render: (_, record) => (
        <span className="text-gray-700 text-sm">{record?.type}</span>
      ),
    },
    ...(withdrawHistory.some((r) => r.bank_name)
      ? [
          {
            title: "Bank Name",
            sorter: true,
            render: (_, record) => (
              <span className="text-gray-700 text-sm">
                {record?.bank_name || "N/A"}
              </span>
            ),
          },
        ]
      : []),
    ...(withdrawHistory.some((r) => r.account_no)
      ? [
          {
            title: "Account Num",
            sorter: true,
            render: (_, record) => (
              <span className="text-gray-700 text-sm">
                {record?.account_no || "N/A"}
              </span>
            ),
          },
        ]
      : []),
    ...(withdrawHistory.some((r) => r.account_holder_name)
      ? [
          {
            title: "Account Holder Name",
            sorter: true,
            render: (_, record) => (
              <span className="text-gray-700 text-sm">
                {record?.account_holder_name || "N/A"}
              </span>
            ),
          },
        ]
      : []),
    ...(withdrawHistory.some((r) => r.ifsc_code)
      ? [
          {
            title: "IFSC Code",
            sorter: true,
            render: (_, record) => (
              <span className="text-gray-700 text-sm">
                {record?.ifsc_code || "N/A"}
              </span>
            ),
          },
        ]
      : []),
    ...(withdrawHistory.some((r) => r.upi_id)
      ? [
          {
            title: "UPI Id",
            sorter: true,
            render: (_, record) => (
              <span className="text-gray-700 text-sm">
                {record?.upi_id || "N/A"}
              </span>
            ),
          },
        ]
      : []),
    {
      title: "Remarks",
      sorter: true,
      render: (_, record) => (
        <span className="text-gray-600 text-sm">{record?.remark}</span>
      ),
    },
    {
      title: "Amount",
      sorter: true,
      render: (_, record) => (
        <span className="font-bold text-[#0c9971] text-sm">
          ₹ {record?.amount}
        </span>
      ),
    },
    {
      title: "Request Date",
      sorter: true,
      render: (_, record) => (
        <span className="text-gray-600 text-sm">
          {new Date(record?.createdAt).toLocaleString()}
        </span>
      ),
    },
    {
      title: "Status",
      sorter: true,
      render: (_, record) => (
        <div>
          {record?.status === "Request" ? (
            <Button
              disabled={button}
              onClick={() => cancelWithdrawRequest(record, "Cancel")}
              className="bg-red-500 hover:bg-red-600 text-white font-medium px-4 py-1 rounded-md shadow-md transition"
            >
              Cancel
            </Button>
          ) : (
            <span
              className={`font-semibold text-sm ${
                record?.status === "Reject"
                  ? "text-red-500"
                  : "text-[#0c9971]"
              }`}
            >
              {record?.status}
            </span>
          )}
        </div>
      ),
    },
  ];

  const getWithdrawHistory = () => {

    let site_code = Appconfig.sitecodes;
    let data = JSON.stringify({
      site_code: site_code,
      user_id: userInfo?._id
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}withdraw/getWithdrawHistory`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          setWithdrawHistory(response.data.resultData);
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });

  };

  function selectPaymentDetail(detail) {
    setBankName(detail?.bankName);
    setAccountNumber(detail?.accountNo);
    setAccountHolder(detail?.accountHolder);
    setIfscCode(detail?.ifscCode);
    setUpiId(detail?.upiId);
    setUpiHolder(detail?.holderName);
    setShowUpiForm(detail?.type);
    setSelectedPaymentDetail(detail); // Set selected payment method detail
    setShowPreviousAccount(true); // Show details section
  }


  useEffect(() => {
    getWithdrawHistory()
    handlePaymentMethod();
  }, []);

  return (
    <>
      {/* <Header /> */}
      {/* <ExposureHeader /> */}
      {/* <div className="breadcrumb">
        <a className="home-link" href="/" title="LotusPlus365-Home">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 576 512"
            fill="var(--icon-color-brand-secondary1)"
          >
            <path
              d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
            ></path>
          </svg>
        </a>
        <div className="breadcrumb-current">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="23"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="var(--icon-color-tertiary2)"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M9 6l6 6l-6 6"></path>
          </svg>
          <a href="/withdraw" className="breadcrumb-item" title="LotusPlus365-Withdraw">
            Withdraw
          </a>
        </div>
      </div> */}

      <div className="lg:flex sticky top-0 app-bg font-lato-bold w-full justify-between items-center lg:pt-0">
        <div>
          <nav
            className="flex items-center justify-center w-max space-x-1 text-sm text-white/80 p-2"
            aria-label="Breadcrumb"
          >
            <a title="LotusPlus365-Home" className="flex items-center" href="/">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 576 512"
                fill="var(--icon-color-brand-secondary1)"
              >
                <path
                  d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
                ></path>
              </svg>
            </a>
            <div className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="23"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="var(--icon-color-tertiary2)"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M9 6l6 6l-6 6"></path>
              </svg>
              <a
                className="ml-1 text-lg transition-all ease-in-out duration-300 text-text_brand_primary font-semibold hover:underline"
                aria-current="page"
                title="LotusPlus365-Withdraw"
                href="/withdraw"
              >
                Withdraw
              </a>
            </div>
          </nav>
        </div>
      </div>

      {/* <div className="card">
        <div className="withdraw-section">
          <div className="balance-display">
            Available Withdraw Amount: ₹{" "}
            <span className="balance-amount">
              {balance && Number(balanceWithExp).toFixed(2)}
            </span>
          </div>

          {/* Select between New or Previous */}
          {/* <div className="flex flex-row gap-4 py-2 mb-1">
            <button
              onClick={() => {
                handleClick("new-account");
                setShowPaymentMethods(true);
                setShowPreviousAccount(false);
              }}
              className={`flex-1 py-3 px-4 rounded-lg font-medium transition ${
                selectedOption === "new-account"
                  ? "bg-[#0c9971] text-white"
                  : "bg-gray-100 hover:bg-gray-200"
              }`}
            >
              Use New Account
            </button>

            <button
              onClick={() => {
                handleClick("previous-account");
                setShowPaymentMethods(false);
                if (paymentMethod?.length > 0) {
                  setShowPreviousAccount(true);
                } else {
                  setShowPreviousAccount(false);
                }
              }}
              className={`flex-1 py-3 px-4 rounded-lg font-medium transition ${
                selectedOption === "previous-account"
                  ? "bg-[#0c9971] text-white"
                  : "bg-gray-100 hover:bg-gray-200"
              }`}
            >
              Use Previous Account
            </button>
          </div> */}


          {/* Show Payment Methods */}
          {/* {showPaymentMethods && ( */}
          {/* <div className="mb-8">
              <h3 className="text-lg font-semibold mb-2">Select Payment Method</h3>
              <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                {Appconfig.withdraw_account_type?.map((type) => (
                  <button
                    key={type}
                    onClick={() => setShowUpiForm(type)}
                    className={`flex flex-col items-center justify-center py-2 border rounded-xl transition hover:shadow-lg ${
                      type === showUpiForm ? "ring-2 ring-[#0c9971]" : ""
                    }`}
                  >
                    <img
                      src={`../Images/${
                        type === "Bank"
                          ? "bank.png"
                          : type === "Gpay"
                          ? "icons8-google-pay.svg"
                          : type === "UPI"
                          ? "icons8-bhim-50.svg"
                          : type === "Phonepe"
                          ? "icons8-phone-pe.svg"
                          : "icons8-paytm.svg"
                      }`}
                      alt={type}
                      className="w-12 h-12 mb-2"
                    />
                    <span className="text-sm font-medium">{type}</span>
                  </button>
                ))}
              </div>
            </div> */}

          {/* <div className="mb-8">
            <h3 className="text-lg font-semibold mb-2">Select Payment Method</h3>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
              {paymentMethod?.length > 0 ? (
                // Only show payment methods that have been used previously
                paymentMethod.map((method) => (
                  <button
                    key={method.type}
                    onClick={() => setShowUpiForm(method.type)}
                    className={`flex flex-col items-center justify-center py-2 border rounded-xl transition hover:shadow-lg ${method.type === showUpiForm ? "ring-2 ring-[#0c9971]" : ""
                      }`}
                  >
                    <img
                      src={`../Images/${method.type === "Bank"
                        ? "bank.png"
                        : method.type === "Gpay"
                          ? "icons8-google-pay.svg"
                          : method.type === "UPI"
                            ? "icons8-bhim-50.svg"
                            : method.type === "Phonepe"
                              ? "icons8-phone-pe.svg"
                              : "icons8-paytm.svg"
                        }`}
                      alt={method.type}
                      className="w-12 h-12 mb-2"
                    />
                    <span className="text-sm font-medium">{method.type}</span>
                  </button>
                ))
              ) : (
                <div className="col-span-full text-center text-gray-600">
                  No previous payment methods available.
                </div>
              )}
            </div>
          </div> */}


          {/* )} */}

          {/* Show Previous Accounts */}
          {/* {selectedOption === "previous-account" && ( */}
          {/* <>
              {paymentMethod?.length > 0 ? (
                <div className="space-y-4 mb-8">
                  {paymentMethod.map((method) => (
                    <div
                      key={method._id}
                      onClick={() => selectPaymentDetail(method)}
                      className={`border rounded-xl p-4 cursor-pointer transition hover:shadow-lg ${
                        showUpiForm === method?.type ? "ring-2 ring-[#0c9971]" : ""
                      }`}
                    >
                      <div className="flex items-center space-x-4">
                        <img
                          src={`../Images/${
                            method?.type === "Bank"
                              ? "bank.webp"
                              : method?.type === "Gpay"
                              ? "G-pay.webp"
                              : method?.type === "UPI"
                              ? "icons8-bhim-50.svg"
                              : method?.type === "Phonepe"
                              ? "phonepe.webp"
                              : "paytm.webp"
                          }`}
                          alt={method?.type}
                          className="w-10 h-10"
                        />
                        <div className="flex-1">
                          <h4 className="font-semibold">{method?.type} Details</h4>
                          <table className="text-sm text-gray-700">
                            <tbody>
                              <tr>
                                <td className="pr-2">HOLDER NAME:</td>
                                <td>
                                  {method?.type === "Bank"
                                    ? method?.accountHolder
                                    : method?.holderName}
                                </td>
                              </tr>
                              <tr>
                                <td className="pr-2">
                                  {method?.type === "Bank"
                                    ? "A/C NUMBER:"
                                    : "UPI ID:"}
                                </td>
                                <td>
                                  {method?.type === "Bank"
                                    ? method?.accountNo
                                    : method?.upiId}
                                </td>
                              </tr>
                              {method?.type === "Bank" && (
                                <>
                                  <tr>
                                    <td className="pr-2">IFSC CODE:</td>
                                    <td>{method?.ifscCode}</td>
                                  </tr>
                                  <tr>
                                    <td className="pr-2">BANK NAME:</td>
                                    <td>{method?.bankName}</td>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            deletePaymentDetails(method._id);
                          }}
                          className="text-red-500 hover:text-red-700 text-sm"
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-8 text-gray-600">
                  No previous entries available.
                </div>
              )}
            </> */}
          {/* )} */}

          {/* Payment Details Form */}
          {/* {(showUpiForm || selectedOption === "previous-account") && (
            <form onSubmit={handleSubmitClick} className="space-y-4">

              <div className="w-full py-[15px] rounded-lg bg-bg_color_primary px-3">
                <div className="w-full mb-2">
                  <span className="text-sm bg-bg_text_brand_primary rounded text-text_color_primary2 shadow-md px-2 py-1">
                    Current Available Balance: ₹ {balance && Number(balanceWithExp).toFixed(2)}
                  </span>
                </div>
                <label
                  htmlFor="amount"
                  className="font-lato font-bold text-text_color_primary1 text-base leading-5"
                >
                  Amount
                </label>

                Main amount input
                <div className="w-full mt-2 py-2 bg-bg_color_input_bg grid grid-cols-12 border rounded-[4px] px-2 items-center justify-center border-border_color_success font-semibold">
                  <input
                    id="amount"
                    type="number"
                    value={amountValue}
                    onChange={(e) => setAmountValue(e.target.value)}
                    placeholder="₹ Enter Amount"
                    required
                    autoComplete="off"
                    className="block w-full focus:outline-none col-span-11 text-text_color_primary1 bg-transparent font-lato placeholder:font-lato placeholder:font-normal font-bold text-base border-none p-0"
                  />
                  <span className="font-lato font-bold leading-4 text-text_color_primary1 text-base col-span-1 text-center font-semibold">
                    INR
                  </span>
                </div>
              </div>

              <h4 className="text-lg font-semibold">
                Available to Withdraw: ₹{balance && Number(balanceWithExp).toFixed(2)}
              </h4>
              <span
                  class="text-sm mt-1 bg-bg_text_brand_primary rounded font-roboto shadow-md text-text_color_primary2  px-2 py-1 my-1">
                  Available to withdrawal : ₹ {balance && Number(balanceWithExp).toFixed(2)} 
              </span>

              <input
                type="number"
                value={amountValue}
                onChange={(e) => setAmountValue(e.target.value)}
                placeholder="₹ Enter Amount"
                className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0c9971]"
              />

              {showUpiForm === "Bank" && selectedOption === "new-account" && (
                <>
                  <input
                    type="text"
                    value={ifscCode}
                    onChange={(e) => setIfscCode(e.target.value)}
                    placeholder="Enter IFSC Code"
                    className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0c9971]"
                  />
                  <span className="text-red-500 text-sm">{IfscValidationError}</span>

                  <input
                    type="number"
                    value={accountNumber}
                    onChange={(e) => setAccountNumber(e.target.value)}
                    placeholder="Enter Account Number"
                    className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0c9971]"
                  />
                  <span className="text-red-500 text-sm">{AcNumValidationError}</span>

                  <input
                    type="text"
                    value={bankName}
                    onChange={(e) => setBankName(e.target.value)}
                    placeholder="Enter Bank Name"
                    className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0c9971]"
                  />
                  <span className="text-red-500 text-sm">{BankValidationError}</span>

                  <input
                    type="text"
                    value={accountHolder}
                    onChange={(e) => setAccountHolder(e.target.value)}
                    placeholder="Enter Account Name"
                    className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0c9971]"
                  />
                  <span className="text-red-500 text-sm">{AcHolderValidationError}</span>
                </>
              )}

              {(showUpiForm === "UPI" ||
                showUpiForm === "Phonepe" ||
                showUpiForm === "Gpay" ||
                showUpiForm === "Paytm") &&
                selectedOption === "new-account" && (
                  <>
                    <input
                      type="text"
                      value={upiId}
                      onChange={(e) => setUpiId(e.target.value)}
                      placeholder={`Enter ${showUpiForm} ID`}
                      className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0c9971]"
                    />
                    <span className="text-red-500 text-sm">{UPIValidationError}</span>

                    <input
                      type="text"
                      value={upiHolder}
                      onChange={(e) => setUpiHolder(e.target.value)}
                      placeholder={`Enter ${showUpiForm} Holder Name`}
                      className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0c9971]"
                    />
                    <span className="text-red-500 text-sm">{HolderValidationError}</span>
                  </>
                )}

              <label className="flex items-center space-x-2 text-sm">
                <input type="checkbox" className="accent-[#0c9971]" />
                <span>
                  I have read the{" "}
                  <a href="#" className="underline text-[#0c9971]">
                    terms of payment and withdrawal policy
                  </a>
                </span>
              </label>

              <button
                type="submit"
                disabled={isSubmitted}
                className={`w-full py-3 rounded-lg font-semibold text-white transition ${
                  isSubmitted
                    ? "bg-green-500 cursor-not-allowed"
                    : "bg-[#0c9971] hover:bg-[#0a8060]"
                }`}
              >
                {buttonText}
              </button>
            </form>
          )} */}

          {/* Withdraw Submit Button */}
          {/* <div className="w-full mt-4">
            <button
              type="button"
              disabled={
                !amountValue ||
                !showUpiForm ||
                (!accountNumber && !upiId) ||
                isSubmitted
              }
              onClick={handleSubmitClick}
              className={`w-full py-3 rounded-lg font-semibold text-white transition ${isSubmitted
                ? "bg-green-500 cursor-not-allowed"
                : "bg-[#0c9971] hover:bg-[#0a8060]"
                }`}
            >
              {buttonText}
            </button>
          </div> */}

        {/* <div className="payment-methods-section">
          <h3>Select Payment Method</h3>
          <div className="payment-methods-grid">
            {paymentMethod?.length > 0 ? (
              paymentMethod.map((method) => {
                return (
                  method.status == "Active" ?
                    <button
                      key={method.type}
                      onClick={() => selectPaymentDetail(method)}
                      className={`payment-button ${method.type === showUpiForm ? "active" : ""}`}
                    >
                      <img
                        src={`../Images/${method.type === "Bank"
                          ? "bank.png"
                          : method.type === "Gpay"
                            ? "icons8-google-pay.svg"
                            : method.type === "UPI"
                              ? "icons8-bhim-50.svg"
                              : method.type === "Phonepe"
                                ? "icons8-phone-pe.svg"
                                : "icons8-paytm.svg"
                          }`}
                        alt={method.type}
                        className="payment-icon"
                      />
                      <span className="payment-label">{method.type}</span>
                    </button>
                    :
                    <div className="no-methods">No previous payment methods available.</div>

                )
              })
            ) : (
              <div className="no-methods">No previous payment methods available.</div>
            )}
          </div>
        </div> */}

        {/* <div className="submit-section">
          <button
            type="button"
            disabled={
              !amountValue || !showUpiForm || (!accountNumber && !upiId) || isSubmitted
            }
            onClick={handleSubmitClick}
            className={`submit-button ${isSubmitted ? "disabled" : ""}`}
          >
            {buttonText}
          </button>
        </div> */}

      <div className="bg-white rounded-xl shadow-xl p-6">
        <div className="w-full py-[15px] rounded-lg bg-bg_color_primary px-3">
          <div className="w-full mb-2">
            <span className="text-sm bg-bg_text_brand_primary rounded text-text_color_primary2 shadow-md px-2 py-1">
              Available Withdraw Amount: ₹ {balance && Number(balanceWithExp).toFixed(2)}
            </span>
          </div>
          <label
            htmlFor="amount"
            className="font-lato font-bold text-text_color_primary1 text-base leading-5"
          >
            Amount
          </label>

          {/* Main amount input */}
          <div className="w-full mt-2 py-2 bg-bg_color_input_bg grid grid-cols-12 border rounded-[4px] px-2 items-center justify-center border-border_color_success font-semibold">
            <input
              id="amount"
              type="number"
              value={amountValue}
              onChange={(e) => setAmountValue(e.target.value)}
              placeholder="₹ Enter Amount"
              required
              autoComplete="off"
              className="block w-full focus:outline-none col-span-11 text-text_color_primary1 bg-transparent font-lato placeholder:font-lato placeholder:font-normal font-bold text-base border-none p-0"
            />
            <span className="font-lato font-bold leading-4 text-text_color_primary1 text-base col-span-1 text-center font-semibold">
              INR
            </span>
          </div>
        </div>

        
        <div className="mb-8">
          <h3 className="text-lg font-semibold mb-2">Select Payment Method</h3>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
            {paymentMethod?.length > 0 ? (
              paymentMethod.map((method, idx) => {
                // Use a unique key and compare the full method object
                const isSelected = selectedPaymentDetail && JSON.stringify(selectedPaymentDetail) === JSON.stringify(method);
                return (
                  <button
                    key={method.type + '-' + idx}
                    onClick={() => selectPaymentDetail(method)}
                    className={`flex flex-col items-center justify-center py-2 border rounded-xl transition hover:shadow-lg ${isSelected ? "ring-2 ring-[#0c9971] border-[#0c9971]" : "border-gray-300"}`}
                  >
                    <img
                      src={`../Images/${
                        method.type === "Bank"
                          ? "bank.png"
                          : method.type === "Gpay"
                          ? "icons8-google-pay.svg"
                          : method.type === "UPI"
                          ? "icons8-bhim-50.svg"
                          : method.type === "Phonepe"
                          ? "icons8-phone-pe.svg"
                          : "icons8-paytm.svg"
                      }`}
                      alt={method.type}
                      className="w-12 h-12 mb-2"
                    />
                    <span className="text-sm font-medium">{method.type}</span>
                  </button>
                );
              })
            ) : (
              <div className="col-span-full text-center text-gray-600">
                No previous payment methods available.
              </div>
            )}
          </div>

          {/* Payment Method Details Section - moved here */}
          <div className="mt-4 px-4">
            {showPreviousAccount && selectedPaymentDetail && (
              <div className="bg-white shadow-md rounded-xl p-5 max-w-3xl mx-auto">
                <h1 className="text-[#0c9971] text-lg font-semibold mb-4">
                  {selectedPaymentDetail.type === "Bank"
                    ? "Bank Details"
                    : `${selectedPaymentDetail.type} Details`}
                </h1>

                <div className="overflow-x-auto">
                  <table className="w-full text-sm sm:text-base text-gray-800">
                    <tbody>
                      {selectedPaymentDetail.type === "Bank" ? (
                        <>
                          <tr className="border-b">
                            <td className="py-2 font-medium w-1/3">Name</td>
                            <td className="text-center w-4">-</td>
                            <td className="pl-2">{selectedPaymentDetail?.accountHolder || "-"}</td>
                          </tr>
                          <tr className="border-b">
                            <td className="py-2 font-medium">A/c Number</td>
                            <td className="text-center">-</td>
                            <td className="pl-2">{selectedPaymentDetail?.accountNo || "-"}</td>
                          </tr>
                          <tr className="border-b">
                            <td className="py-2 font-medium">IFSC Code</td>
                            <td className="text-center">-</td>
                            <td className="pl-2">{selectedPaymentDetail?.ifscCode || "-"}</td>
                          </tr>
                          <tr className="border-b">
                            <td className="py-2 font-medium">Bank Name</td>
                            <td className="text-center">-</td>
                            <td className="pl-2">{selectedPaymentDetail?.bankName || "-"}</td>
                          </tr>
                          {selectedPaymentDetail?.upiId && (
                            <tr className="border-b">
                              <td className="py-2 font-medium">UPI ID</td>
                              <td className="text-center">-</td>
                              <td className="pl-2">{selectedPaymentDetail?.upiId}</td>
                            </tr>
                          )}
                        </>
                      ) : (
                        <>
                          <tr className="border-b">
                            <td className="py-2 font-medium">{selectedPaymentDetail.type} ID</td>
                            <td className="text-center">-</td>
                            <td className="pl-2">{selectedPaymentDetail?.upiId || "-"}</td>
                          </tr>
                          <tr className="border-b">
                            <td className="py-2 font-medium">Holder Name</td>
                            <td className="text-center">-</td>
                            <td className="pl-2">{selectedPaymentDetail?.holderName || "-"}</td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>

        </div>

          
        {/* )} */}

        {/* Withdraw Submit Button */}
          <div className="w-full mt-4">
            <button
              type="button"
              disabled={
                !amountValue ||
                !showUpiForm ||
                (!accountNumber && !upiId) ||
                isSubmitted
              }
              onClick={handleSubmitClick}
              className={`w-full py-2 rounded-lg font-semibold text-white transition ${
                isSubmitted
                  ? "bg-green-500 cursor-not-allowed"
                  : "bg-[#0c9971] hover:bg-[#0a8060]"
              }`}
            >
              {buttonText}
            </button>
          </div> 
      </div>

      {/* {showWithdrawHistory && (
        <div className="mt-4">
          <h3 className="text-xl font-semibold mb-4 text-gray-900">
            Withdraw History
          </h3>
          <div className="overflow-x-auto">
            <Table
              columns={historyColumns}
              className="min-w-full border border-gray-200 rounded-lg bg-white custom-white-table"
              bordered
              dataSource={withdrawHistory}
              pagination={true}
            />
          </div>
        </div>
      )} */}
      {showWithdrawHistory && (
        <div className="mt-6">
          <div className="bg-white shadow-lg rounded-2xl p-1">
            <h3 className="text-2xl font-bold mb-2 text-gray-900">
              Withdraw History
            </h3>
            <div className="overflow-x-auto">
              <Table
                columns={historyColumns}
                dataSource={withdrawHistory}
                pagination={{ pageSize: 10 }}
                bordered
                rowClassName="hover:bg-gray-50"
                className="rounded-lg overflow-hidden custom-green-header"
                scroll={{ x: "max-content" }}
              />
            </div>
          </div>
        </div>
      )}


      <div className="w-full flex flex-row items-center justify-center gap-3 mt-4 flex-wrap">
        <div className="">
          <button
            onClick={() => setShowWithdrawHistory(!showWithdrawHistory)}
            className="px-4 py-2 bg-[#0c9971] text-white rounded font-semibold"
          >
            {showWithdrawHistory ? "Hide Withdraw History" : "Show Withdraw History"}
          </button>

          
        </div>
        {/* Add Withdraw Method Button */}
        <div className=" flex justify-end">
          <button
            type="button"
            className="px-4 py-2 bg-[#0c9971] text-white rounded font-semibold shadow hover:bg-[#0a8060] transition"
            onClick={() => navigate("/add-withdraw-method")}
          >
            Add Withdraw Method
          </button>
        </div>
      </div>

      

      {/* ...existing code... */}

    </>

  );
};

export default Withdraw;
